
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTideHigh as ObiTideHighElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-tide-high.js';
 
 
 

 
 export const ObiTideHigh = createComponent({
   react: React,
   tagName: 'obi-tide-high',
   elementClass: ObiTideHighElement,
   events: {
     
   }
  });
 
 